import request from "./../utils/request.js";


export function getShareDetail(id) {
  return request.get('share/detail/', { id: id })
}


export function getArticleCategoryList(pid){
  return request.get('article/category/',{pid:pid},{noAuth:true})
}

/*
文章搜索
*/
export function getArticleslist(data){
  return request.get('article/search/',data,{noAuth:true});
}

/*
文章搜索
*/
export function addArticle(data){
  return request.post('article/add',data);
}


/**
 * 文章评价
 * @param object data
 * 
*/
export function addComment(data){
  return request.post('comment/add_comment',data);
}

/**
 * 文章评论列表
 * @param object data
 * 
*/
export function replylist(id,page,limit){
  return request.get('comment/replylist/' ,{ 
    id:id,
    page: page === undefined ? 1 : page, 
    limit:limit === undefined ? 10 :limit
  },{noAuth:true});
}

/**
 * 文章列表
 * @param int cid
 * 
*/
export function getArticleList(cid,data){
  return request.get('article/sharelist/' + cid, data,{noAuth:true})
}

export function getArticleList1(uid,data){
  return request.get('article/sharelists/' + uid, data,{noAuth:true})
}

/**
 * 文章点赞
 * @param object data
 * 
*/
export function addflower(data){
  return request.post('comment/flower',data);
}

//学生信息
export function studentinfo(uid){
  return request.get('user/student/info/' + uid)
}

//在麦吉圈中显示
export function workShow(id){
  return request.get('work/show/' + id)
}
